// External Imports
import { Fragment, h } from 'preact';
import { BodyText, Layout, Stack, Title, pxToRem, styled } from '@lessonnine/design-system.lib';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

// Internal Imports
import { useStore } from '../../state/context';
import { LayoutWithSiteMaxWidth } from '../LayoutWithSiteMaxWidth/LayoutWithSiteMaxWidth';
import { GettingStartedCard } from './GettingStartedCard';
import bookYourClass from '../../assets/images/book-your-class.webp';
import startSpeaking from '../../assets/images/start-speaking.webp';

// Local Variables
const desktopBreakpoint = parseInt(tokens.viewports.breakpoints.medium, 10);
const BrandColorText = styled.span`
  color: ${({ theme }) => theme.color.brand.default};
  font-style: italic;
`;

const Separator = styled.hr`
  border: none;
  @media (min-width: ${pxToRem(desktopBreakpoint)}) {
    min-height: 100%;
    border-right: 1px solid ${({ theme }) => theme.color.lines.default};
  }
`;

const BodyTextWithMaxWidth = styled(BodyText)`
  padding: 0 16px;
  max-width: ${pxToRem(742)};
`;

function GettingStartedSection() {
  const { t } = useStore();
  const leftBulletPoints = [
    t.get_started.step1.bullets.one,
    t.get_started.step1.bullets.two,
    t.get_started.step1.bullets.three,
  ];

  const rightBulletPoints = [
    t.get_started.step2.bullets.one,
    t.get_started.step2.bullets.two,
    t.get_started.step2.bullets.three,
  ];
  const gettingStartedContent = [
    {
      bulletPoints: leftBulletPoints,
      image: bookYourClass,
      step: t.get_started.step1.count,
      title: t.get_started.step1.title,
    },
    {
      bulletPoints: rightBulletPoints,
      image: startSpeaking,
      step: t.get_started.step2.count,
      title: t.get_started.step2.title,
    },
  ];

  return (
    <Stack
      alignItems="center"
      padding={{ medium: [0, pxToRem(154), pxToRem(80), pxToRem(154)], small: [pxToRem(48), 0] }}
    >
      <LayoutWithSiteMaxWidth direction="stack" gap={40}>
        <Stack alignItems="center" gap={24} padding={[0, pxToRem(16)]}>
          <Title as="h2" size={{ medium: 'large', small: 'small' }} textAlign="center">
            {t.get_started.headline.part1}{' '}
            <BrandColorText>{t.get_started.headline.part2}</BrandColorText>
          </Title>
          <BodyTextWithMaxWidth size={{ medium: 'default', small: 'small' }} textAlign="center">
            {t.get_started.subheadline}
          </BodyTextWithMaxWidth>
        </Stack>
        <Layout
          align="center"
          alignItems={{ medium: 'stretch', small: 'center' }}
          direction={{ small: 'inline', xsmall: 'stack' }}
          gap={{ medium: 50, small: 16 }}
          wrap={{ medium: false, xsmall: true }}
        >
          {gettingStartedContent.map(({ bulletPoints, image, step, title }, index) => (
            <Fragment>
              <GettingStartedCard
                bulletPoints={bulletPoints}
                image={image}
                key={title}
                step={step}
                title={title}
              />
              {gettingStartedContent.length !== index + 1 && <Separator />}
            </Fragment>
          ))}
        </Layout>
      </LayoutWithSiteMaxWidth>
    </Stack>
  );
}

export { GettingStartedSection };
